import { Box, Stack, Typography } from "@mui/material"
import { styles as diplomaStyles } from "../styles/Diploma.styles"
import Image from "components/Image"
import { useTranslation } from "react-i18next"
import { masterBreakPoint } from "themes/default/breakpoints"
import { useAuthContext } from "contexts/AuthContext"

const dateText = {
  1: "fecha",
  2: "date",
  3: "date",
}

export default function Diploma({
  width = "960px",
  height = "700px",
  title = "",
  reason = "",
  studentName = "",
  dedication = "",
  date,
  teacherName = "",
  smashyImage,
  textSize = 60,
  medalWidth = "15vh",
  lineStroke = 3,
  message = "",
  teacherTitle = "teacher",
  diplomasBg,
  onImageLoaded = () => { },
  isKidDiploma = true,
}) {
  const { t } = useTranslation()
  const { userData, selectedGroupData } = useAuthContext()
  const styles = diplomaStyles(textSize)
  const nameFontSize = textSize * 0.7 - (studentName?.length - 14) * 4
  const learningLanguage = userData?.isB2C
    ? userData?.b2C?.languageToLearn
    : selectedGroupData?.learningLanguageId || -1

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={[
        styles.content,
        !isKidDiploma && styles.secondaryContent,
        { width, height },
      ]}
    >
      <Stack
        sx={[
          styles.diplomaSmash,
          diplomasBg && {
            backgroundImage: `url(${diplomasBg})`,
          },
          !isKidDiploma && styles.diplomaSmash2,
        ]}
      >
        {isKidDiploma && (
          <Stack alignItems={"center"} pl={1.25}>
            <Image name="logo2" width={"70%"} height="auto" />
          </Stack>
        )}
        {smashyImage && (
          <Stack alignItems={"center"} pl={1.25}>
            <Image
              src={smashyImage}
              width={isKidDiploma ? "55%" : "100%"}
              height="auto"
              onLoad={onImageLoaded}
              onError={onImageLoaded}
            />
          </Stack>
        )}
        {isKidDiploma && (
          <Stack alignItems={"center"} pl={1.25}>
            <Typography variant="span" sx={[styles.smashFooter]}>
              {message}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack
        sx={[styles.diplomaDetails, !isKidDiploma && styles.diplomaDetails2]}
      >
        <Stack sx={[styles.section, !isKidDiploma && styles.section2]}>
          <Stack gap={isKidDiploma ? 3.75 : 1.25}>
            {isKidDiploma ? (
              <Typography variant="span" sx={[styles.title]}>
                DIPLOMA
              </Typography>
            ) : (
              <Box
                component="img"
                src={require("assets/img/rewards/diploma-title.png")}
                sx={styles.titleImg}
              />
            )}

            <Typography
              variant="span"
              sx={[styles.title2, !isKidDiploma && styles.title21]}
            >
              {title}
            </Typography>
          </Stack>
        </Stack>
        <Stack sx={[styles.section, !isKidDiploma && styles.section2]}>
          <Stack>
            <Typography
              variant="span"
              sx={[
                styles.user,
                !isKidDiploma && styles.user2,
                studentName?.length > 14 && {
                  fontSize: nameFontSize < 40 ? 30 : nameFontSize,
                  [masterBreakPoint]: {
                    fontSize: nameFontSize < 40 ? 30 : nameFontSize,
                  },
                },
              ]}
            >
              {studentName}
            </Typography>
            <Box
              sx={[
                styles.userLine,
                { height: lineStroke },
                !isKidDiploma && styles.userLine2,
              ]}
            >
              {!isKidDiploma && (
                <Typography variant="span" sx={styles.lineSpan} />
              )}
            </Box>
            {!isKidDiploma && (
              <Typography variant="p" sx={[styles.encouragement]}>
                {message}
              </Typography>
            )}
            <Typography
              variant="span"
              sx={[styles.reason, !isKidDiploma && styles.reason2]}
            >
              {reason}
            </Typography>
          </Stack>
        </Stack>
        <Stack sx={[styles.section, !isKidDiploma && styles.section2]}>
          <Stack
            direction="row"
            alignItems={"center"}
            justifyContent={"center"}
            flexWrap="nowrap"
            gap={1.25}
            sx={styles.diplomaSignature}
          >
            <Stack
              sx={[
                styles.signatureSection,
                !isKidDiploma && styles.signatureSection2,
              ]}
            >
              <Typography
                // variant="span"
                sx={[
                  styles.signatureTitle,
                  {
                    borderBottom: `${lineStroke}px solid #f4c34e`,
                  },
                  !isKidDiploma && styles.signatureTitle2,
                ]}
              >
                {date}
              </Typography>
              <Typography
                sx={[
                  styles.signatureLabel,
                  !isKidDiploma && styles.signatureLabel2,
                ]}
              >
                {dateText[learningLanguage] || t("date")}
              </Typography>
            </Stack>
            {isKidDiploma && (
              <Stack sx={styles.signatureSeal}>
                <Image name="smashMedal" width={"140px"} height={"auto"} />
              </Stack>
            )}
            <Stack sx={styles.signatureSection}>
              <Typography
                sx={[
                  styles.signatureTitle,
                  {
                    width: 170,
                    borderBottom: `${lineStroke}px solid #f4c34e`,
                  },
                  !isKidDiploma && styles.signatureTitle2,
                ]}
              >
                {teacherName}
              </Typography>
              <Typography
                sx={[
                  styles.signatureLabel,
                  !isKidDiploma && styles.signatureLabel2,
                ]}
              >
                {teacherTitle}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack sx={[styles.section, !isKidDiploma && styles.section2]}>
          <Typography
            variant="span"
            sx={[
              styles.diplomaDedication,
              !isKidDiploma && styles.diplomaDedication2,
            ]}
          >
            {"“"}
            {dedication}
            {"”"}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
